import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionTypeIconFillInTheBlank = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.25 12.75V19.5C17.25 19.6989 17.171 19.8897 17.0303 20.0303C16.8897 20.171 16.6989 20.25 16.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V7.5C3.75 7.30109 3.82902 7.11032 3.96967 6.96967C4.11032 6.82902 4.30109 6.75 4.5 6.75H11.25",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4698 11.6251H12.375C12.2755 11.6251 12.1802 11.5856 12.1098 11.5152C12.0395 11.4449 12 11.3495 12 11.2501V9.15522C12 9.05589 12.0395 8.96064 12.1097 8.89037L17.8903 3.10975C17.9606 3.03948 18.056 3 18.1554 3C18.2548 3 18.3501 3.03948 18.4205 3.10975L20.5153 5.20319C20.5856 5.2735 20.6251 5.36885 20.6251 5.46826C20.6251 5.56768 20.5856 5.66302 20.5153 5.73334L14.7347 11.5154C14.6644 11.5856 14.5692 11.625 14.4698 11.6251Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 4.50006L19.125 7.12506",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 15H7V17.5H14.5V16.25V15Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] })
});
export default SvgQuestionTypeIconFillInTheBlank;
